// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24; // 1 day
export const TOKEN_COOKIE = "funifier_token";
export const REFRESH_TOKEN_COOKIE = "funifier_refreshToken";
export const TOKEN_EXPIRE_IN_COOKIE = "funifier_tokenExpireIn";
export const BADGES_STORAGE_KEY = "funifier_badges";
export const VERSION = "v1.0.0";
export const COOKIE_PREFIX = "funifier";
